<template>
  <div>
    <van-empty class="bg-white min-vh-100" image="/static/img/pro/404.png" description="页面不存在或已被删除"/>
  </div>

</template>
<script>
  import Vue from 'vue';
  import {Empty} from 'vant';
  import {NavBar} from 'vant';

  Vue.use(NavBar);
  Vue.use(Empty);

  export default {
    name: "errorPage",
    methods: {
      onClickLeft() {
        this.$router.push('/')
      }
    }
  }
</script>

<style scoped>

</style>
